import { FC } from 'react';
import { useIntl } from 'react-intl';

import globalMessages from 'src/messages';
import { phoneLink } from 'src/utils/intlHelper';

import {
    ContactWrapper,
    ContactItem,
    ContactItemHeader,
    ColoredTrialMessage,
} from './Contact';

const ContactUK: FC = () => {
    const intl = useIntl();

    return (
        <ContactWrapper>
            <ContactItem>
                <ContactItemHeader>
                    <span>
                        {intl.formatMessage(globalMessages.phones.callFromUK)}
                    </span>
                </ContactItemHeader>
                <ColoredTrialMessage>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.callFromUkPhone,
                            {
                                a: phoneLink,
                            },
                        )}
                    </span>
                </ColoredTrialMessage>
            </ContactItem>
            <ContactItem>
                <ContactItemHeader>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.callFromOutsideUK,
                        )}
                    </span>
                </ContactItemHeader>
                <ColoredTrialMessage>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.callFromOutsideUkPhone,
                            {
                                a: phoneLink,
                            },
                        )}
                    </span>
                </ColoredTrialMessage>
            </ContactItem>
            <ContactItem>
                <ContactItemHeader>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.callFromCanadaOrAustralia,
                        )}
                    </span>
                </ContactItemHeader>
                <ColoredTrialMessage>
                    <span>
                        <span>
                            {intl.formatMessage(
                                globalMessages.phones
                                    .callFromCanadaOrAustraliaPhone,
                                {
                                    a: phoneLink,
                                },
                            )}
                        </span>
                    </span>
                </ColoredTrialMessage>
            </ContactItem>
        </ContactWrapper>
    );
};

export default ContactUK;
